import { useEffect, useState } from 'react'
//import {UserEditModalHeader} from './UserEditModalHeader'
//import {UserEditModalFormWrapper} from './UserEditModalFormWrapper'
import { ViewModalHeader } from './ViewModalHeader'
import axios from 'axios'
import {
  getdevicesungroup,
  getdevicesungrouptenant,
  getsuscriptions,
  getsuscriptionsglobal,
  getclusters,
  getclustersglobal,
  getips,
  getipstenant
} from '../request/request'
import Swal from 'sweetalert2'
import { useAuth } from '../../../auth'
import { useAppSelector } from '../../../../../redux/hooks'
import { DemoModal } from '../../../../Modal_Demo/ViewModalDemo'

const API_URL = process.env.REACT_APP_API_URL

type ID = undefined | null | number

const CreateCluster = (props: any) => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  // Al abrir el modal limpiamos datos
  useEffect(() => {
    setsusselect(null)
    setctxs([])
    setips([])
    setipsdos([])
    setselect('')
    setselectdos('')
  }, [props.id])

  /********************************* Constantes *****************************************/
  const [ID, setID] = useState<ID>(undefined)
  const tenant = useAppSelector((state) => state.TenantSlice.id)
  const Id = useAppSelector((state) => state.SuscriptionSlice.id)
  const Type = useAppSelector((state) => state.CloudSlice.Type)
  const { currentUser } = useAuth()

  const [susSelect, setsusselect] = useState<any>()
  const [suscription, setsuscripcion] = useState<any[]>([])
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false)

  const [DeviceSelect, setselect] = useState<any>()
  const [DeviceSelectdos, setselectdos] = useState<any>()

  const [ctxs, setctxs] = useState<any[]>([])
  const [Name, setName] = useState('')
  const [Description, setdescription] = useState('')
  const [Localpreferenceuno, setLocalpreferenceuno] = useState('')
  const [Localpreferencedos, setLocalpreferencedos] = useState('')
  const [Local_address, setLocalAddress] = useState('')
  const [Local_addressdos, setLocalAddressdos] = useState('')

  // Para cargar IP al escoger en el select
  const localadd = (e: any) => {
    setLocalAddress(e.target.value)
  }
  const localaddos = (e: any) => {
    setLocalAddressdos(e.target.value)
  }

  // Llamada inicial para llenar Subscriptions
  useEffect(() => {
    if (props.id === null) {
      if (tenant === 0) {
        getsuscriptions().then((response) => {
          setsuscripcion(response.data)
        })
      } else if (tenant !== 0) {
        getsuscriptionsglobal(tenant).then((response) => {
          setsuscripcion(response.data)
        })
      }
    }
  }, [props.id, tenant])

  // Al escoger la suscripción, obtener devices
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (susSelect) {
          if (tenant === 0) {
            const UserResponse = await getdevicesungroup(susSelect)
            setctxs(UserResponse.data)
          } else if (tenant !== 0) {
            const UserResponse = await getdevicesungrouptenant(susSelect, tenant)
            setctxs(UserResponse.data)
          }
        }
      } catch (error) {
        console.error('Error al obtener los dispositivos', error)
      }
    }
    fetchData()
  }, [susSelect])

  const cambiarstate = (e: any) => {
    setselect(e.target.value)
  }
  const ctxdos = (e: any) => {
    setselectdos(e.target.value)
  }

  /********** Se llaman las ips *****************************/
  const [ip, setips] = useState<any[]>([])
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (DeviceSelect) {
          if (tenant === 0) {
            const UserResponse = await getips(DeviceSelect)
            setips(UserResponse.data)
          } else {
            const UserResponse = await getipstenant(DeviceSelect, tenant)
            setips(UserResponse.data)
          }
        }
      } catch (error) {
        console.error('Error al obtener las IPs', error)
      }
    }
    fetchData()
  }, [DeviceSelect])

  const [ipdos, setipsdos] = useState<any[]>([])
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (DeviceSelectdos) {
          if (tenant === 0) {
            const UserResponse = await getips(DeviceSelectdos)
            setipsdos(UserResponse.data)
          } else {
            const UserResponse = await getipstenant(DeviceSelectdos, tenant)
            setipsdos(UserResponse.data)
          }
        }
      } catch (error) {
        console.error('Error al obtener las IPs', error)
      }
    }
    fetchData()
  }, [DeviceSelectdos])

  // Al cambiar DeviceSelect, setear la primera IP
  useEffect(() => {
    if (DeviceSelect && ip.length > 0) {
      setLocalAddress(ip[0].value)
    }
  }, [DeviceSelect, ip])

  // Al cambiar DeviceSelectdos, setear la primera IP
  useEffect(() => {
    if (DeviceSelectdos && ipdos.length > 0) {
      setLocalAddressdos(ipdos[0].value)
    }
  }, [DeviceSelectdos, ipdos])

  // =============================== PRIORITY INFO ALERT ==========================
  const showPriorityInfo = () => {
    Swal.fire({
      title: 'Priority Explanation',
      html: `
        <p>This field determines the order in which announcements are made. 
        A higher value indicates a higher priority for initiating announcements.</p>
        <p>When comparing two entries, the one with the greater value serves 
        as the primary announcement channel, while the one with the lesser value 
        acts as a fallback.</p>
      `,
      icon: 'info',
      confirmButtonText: 'Got it!'
    })
  }

  // =============================== handleSubmit ================================
  const handleSubmit = async (e: any) => {
    e.preventDefault()

    // ============== VALIDACIONES EXACTAS ================
    // 1) No pueden ser iguales
    if (Number(Localpreferenceuno) === Number(Localpreferencedos)) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'The Priorities cannot be the same. Please verify',
        showConfirmButton: true
      })
      return
    }

    // 2) Deben estar entre 1 y 1000
    if (
      Number(Localpreferenceuno) < 1 ||
      Number(Localpreferenceuno) > 1000 ||
      Number(Localpreferencedos) < 1 ||
      Number(Localpreferencedos) > 1000
    ) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Los valores de Priority deben estar entre 1 y 1000.',
        showConfirmButton: true
      })
      return
    }
    // ============== FIN VALIDACIONES ================

    try {
      if (props.id === null) {
        // Check de subscription / name / desc / etc.
        if (susSelect === null) {
          Swal.fire({
            icon: 'error',
            title: 'Please Select Subscription'
          })
          return
        } else if (Name === '') {
          Swal.fire({
            icon: 'error',
            title: 'Please fill in the input Name'
          })
          return
        } else if (Description === '') {
          Swal.fire({
            icon: 'error',
            title: 'Please fill in the input Description'
          })
          return
        } else if (!DeviceSelect) {
          Swal.fire({
            icon: 'error',
            title: 'Please Select CTX-R 1 Name'
          })
          return
        } else if (!DeviceSelectdos) {
          Swal.fire({
            icon: 'error',
            title: 'Please Select CTX-R 2 Name'
          })
          return
        } else if (Localpreferenceuno === '') {
          Swal.fire({
            icon: 'error',
            title: 'Please Select Priority for CTX-R 1'
          })
          return
        } else if (Localpreferencedos === '') {
          Swal.fire({
            icon: 'error',
            title: 'Please Select Priority for CTX-R 2'
          })
          return
        }

        // Construir body
        const body = {
          suscriptionId: susSelect,
          name: Name,
          description: Description,
          ctxr: [
            {
              uuid: DeviceSelect,
              localpref: Localpreferenceuno,
              ip: Local_address
            },
            {
              uuid: DeviceSelectdos,
              localpref: Localpreferencedos,
              ip: Local_addressdos
            }
          ]
        }

        // Enviar post al endpoint
        if (tenant === 0) {
          await axios.post(API_URL + '/v1/ClusterCtxr/create', body).then((res) => {
            if (res.data.error === 'ipid is not ip valid') {
              Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'The neighbors IP address is not valid',
                showConfirmButton: false,
                timer: 1500
              })
            } else if (res.data.error === 'router_id is not ip valid') {
              Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'The router ID IP address is not valid.',
                showConfirmButton: false,
                timer: 1500
              })
            } else if (res.data.error === 'local_address is not ip valid') {
              Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'The local address IP is not valid.',
                showConfirmButton: false,
                timer: 1500
              })
            } else {
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Your Cluster has created',
                showConfirmButton: false,
                timer: 1500
              })
              props.setID(undefined)
            }
          })
        } else {
          // Para cuando tenant != 0
          await axios.post(API_URL + '/v1/ClusterCtxr/create?tenantId=' + tenant, body).then((res) => {
            if (res.data.error === 'ipid is not ip valid') {
              Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'The neighbors IP address is not valid',
                showConfirmButton: false,
                timer: 1500
              })
            } else if (res.data.error === 'router_id is not ip valid') {
              Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'The router ID IP address is not valid.',
                showConfirmButton: false,
                timer: 1500
              })
            } else if (res.data.error === 'local_address is not ip valid') {
              Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'The local address IP is not valid.',
                showConfirmButton: false,
                timer: 1500
              })
            } else {
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Your Cluster has created',
                showConfirmButton: false,
                timer: 1500
              })
              props.setID(undefined)
            }
          })
        }

        // Actualizar la lista de clusters
        if (tenant === 0 && Id !== 0) {
          getclusters(Id).then((response) => {
            props.setrecords(response.data)
          })
        } else if (tenant !== 0 && Id !== 0) {
          getclustersglobal(Id, tenant).then((response) => {
            props.setrecords(response.data)
          })
        } else if (tenant === 0 && Id === 0 && Type === 'Global') {
          getclusters(-1).then((response) => {
            props.setrecords(response.data)
          })
        } else if (tenant !== 0 && Id === 0 && Type === 'Global') {
          getclustersglobal(-1, tenant).then((response) => {
            props.setrecords(response.data)
          })
        }

        // Limpiar form
        setLocalpreferenceuno('')
        setLocalpreferencedos('')
        setName('')
        setdescription('')
      }
    } catch (error: any) {
      console.log(error)
    }
  }

  return (
    <>
      {props.id === null && (
        <div>
          <div
            className='modal fade show d-block'
            id='kt_modal_add_user'
            role='dialog'
            tabIndex={-1}
            aria-modal='true'
          >
            <div className='modal-dialog modal-dialog-centered mw-650px'>
              <div className='modal-content'>
                <ViewModalHeader setID={props.setID} />
                <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
                  <form className='form w-100' id='kt_login_signin_form' onSubmit={handleSubmit}>
                    <div className='text-center mb-5'>
                      <h1 className='text-marino fw-bolder mb-3 f-titulo fs-md'>Create Cluster</h1>
                    </div>

                    <div className='text-center'>
                      <label className='form-label fs-6 fw-bolder text-marino required form-label f-parrafo'>
                        Subscription
                      </label>
                    </div>
                    <div className='d-flex flex-center'>
                      <select
                        className='form-select text-center w-200px border-gray-300 f-parrafo'
                        aria-label='Select example'
                        onChange={(e) => setsusselect(e.target.value)}
                      >
                        {suscription.length === 0 && <option disabled selected hidden>No data</option>}
                        <option hidden>Select a Subscription</option>
                        {suscription.map((ins: any, x: any) => (
                          <option key={x} value={ins.id}>
                            {ins.purchaseOrden}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className='row mt-3'>
                      <div className='col'>
                        <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor='name'>
                          Name
                        </label>
                        <input
                          type='text'
                          name='name'
                          className='form-control form-control-solid border border-gray-300 f-parrafo'
                          id='Nombre'
                          value={Name}
                          onChange={(e: any) => setName(e.target.value)}
                        />
                      </div>
                      <div className='col'>
                        <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor='name'>
                          Description
                        </label>
                        <input
                          type='text'
                          name='name'
                          className='form-control form-control-solid border border-gray-300 f-parrafo'
                          id='Nombre'
                          value={Description}
                          onChange={(e: any) => setdescription(e.target.value)}
                        />
                      </div>
                    </div>

                    {/* Fila CTX-R1 */}
                    <div className='row mt-3'>
                      <div className='col'>
                        <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo'>
                          CTX-R 1
                        </label>
                        <select
                          className='form-select text-center w-200px border border-gray-300 f-parrafo'
                          aria-label='Select example'
                          onChange={cambiarstate}
                        >
                          {ctxs.length === 0 && <option disabled selected hidden>No data</option>}
                          <option disabled selected hidden defaultValue={0}>
                            Select a Device
                          </option>
                          {ctxs.map((ins: any, x: any) => (
                            <option key={x} value={ins.id}>
                              {ins.name} ({ins.description})
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className='col'>
                        <label
                          className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo'
                          htmlFor='descripcion'
                        >
                          IP for HA
                        </label>
                        <select
                          className='form-select text-center border border-gray-300 f-parrafo'
                          aria-label='Select example'
                          onChange={localadd}
                        >
                          {ip?.length === 0 && <option disabled selected hidden>No data</option>}
                          <option disabled selected hidden defaultValue={0}>
                            Select an IP
                          </option>
                          {ip.length !== 0 &&
                            ip.map((ips: any, x: any) => (
                              <option key={x} value={ips.value}>
                                {ips.value}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className='col'>
                        <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo'>
                          Priority
                        </label>
                        {/* Ícono clicable => showPriorityInfo */}
                        <i
                          className='fas fa-exclamation-circle ms-2 fs-7'
                          style={{ cursor: 'pointer' }}
                          onClick={showPriorityInfo}
                        ></i>
                        <input
                          type='number'
                          min={1}
                          name='localpref'
                          className='form-control form-control-solid border border-gray-300 f-parrafo'
                          id='Localpref'
                          value={Localpreferenceuno}
                          onChange={(e: any) => setLocalpreferenceuno(e.target.value)}
                        />
                      </div>
                    </div>

                    {/* Fila CTX-R2 */}
                    <div className='row mt-3'>
                      <div className='col'>
                        <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo'>
                          CTX-R 2
                        </label>
                        <select
                          className='form-select text-center w-200px border border-gray-300 f-parrafo'
                          aria-label='Select example'
                          onChange={ctxdos}
                        >
                          {ctxs.length === 0 && <option disabled selected hidden>No data</option>}
                          <option disabled selected hidden defaultValue={0}>
                            Select a Device
                          </option>
                          {ctxs
                            .filter((insta: any) => insta.id !== DeviceSelect) // Filtrar para no repetir el de CTX-R 1
                            .map((insta: any, x: any) => (
                              <option key={x} value={insta.id}>
                                {insta.name} ({insta.description})
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className='col'>
                        <label
                          className='fform-label fs-6 fw-bolder text-dark required form-label f-parrafo'
                          htmlFor='descripcion'
                        >
                          IP for HA
                        </label>
                        <select
                          className='form-select text-center border border-gray-300 f-parrafo'
                          aria-label='Select example'
                          onChange={localaddos}
                        >
                          {ipdos?.length === 0 && <option disabled selected hidden>No data</option>}
                          <option disabled selected hidden defaultValue={0}>
                            Select an IP
                          </option>
                          {ipdos.length !== 0 &&
                            ipdos.map((ips: any, x: any) => (
                              <option key={x} value={ips.value}>
                                {ips.value}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className='col'>
                        <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo'>
                          Priority
                        </label>
                        {/* Ícono clicable => showPriorityInfo */}
                        <i
                          className='fas fa-exclamation-circle ms-2 fs-7'
                          style={{ cursor: 'pointer' }}
                          onClick={showPriorityInfo}
                        ></i>
                        <input
                          type='number'
                          min={1}
                          name='localpref'
                          className='form-control form-control-solid border border-gray-300 f-parrafo'
                          id='Localpref'
                          value={Localpreferencedos}
                          onChange={(e: any) => setLocalpreferencedos(e.target.value)}
                        />
                      </div>
                    </div>

                    <br />
                    {currentUser?.is_demo !== true && (
                      <div className='d-grid mb-10 justify-content-center'>
                        <div className='row'>
                          <div className='col'>
                            <button type='submit' id='kt_sign_in_submit' className='btn btn-primary'>
                              {!loading && <span className='indicator-label'>Save</span>}
                              {loading && (
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                  Please wait...
                                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                              )}
                            </button>
                          </div>
                          <div className='col'>
                            <button
                              className='btn-cancel btn border border-pink text-pink f-parrafo'
                              style={{ width: '200px' }}
                              onClick={() => props.setID(undefined)}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {currentUser?.is_demo === true && (
                      <div className='d-flex justify-content-center'>
                        <button onClick={() => setID(null)} type='submit' id='kt_sign_in_submit'>
                          Add
                        </button>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className='modal-backdrop fade show'></div>
        </div>
      )}

      {ID !== undefined && <DemoModal setID={setID} id={ID} />}
    </>
  )
}

export { CreateCluster }
